import pluralize from "pluralize";
pluralize.addSingularRule(/en$/i, "");
